import Vue from 'vue'
import Router from 'vue-router'
import Home from './views/home'
import myRouteView from './components/myRouteView'

Vue.use(Router)

export default new Router({
    mode: 'history',
    base: process.env.BASE_URL,
    scrollBehavior() {
        return {x: 0, y: 0}
    },
    routes: [
        {
            path: '/login',
            name: 'login',
            component: () => import(/* webpackChunkName: "login" */ './views/login')
        }
    ]
})

/*
* meta.menuIndex:菜单active位置
* submenu:是否折叠 没有route
* */
export let pages = [{
    path: '/',
    name: 'Home',
    component: Home,
    children: [
        {
            path: 'accountManagement',
            name: 'accountManagement',
            component: () => import(/* webpackChunkName:"accountManagement" */ './views/accountManagement'),
            meta: {
                name: '账号管理',
                menuIndex: 'accountManagement'
            }
        },
        {
            path: 'platformReportTotal',
            component: myRouteView,
            redirect: '/',
            meta: {
                name: '平台总报表',
                menuIndex: 'platformReport',
                submenu: true
            },
            children: [
                    {
                        path: 'platformReport',
                        name: 'platformReport',
                        component: () => import(/* webpackChunkName:"platformReport" */ './views/platformReport'),
                        meta: {
                            name: '平台报表',
                            menuIndex: 'platformReport'
                        }
                    },
        ]
    },
        {
            path: 'dataQuery',
            component: myRouteView,
            meta: {
                name: '数据查询',
                menuIndex: 'dataQuery'
            },
            children: [
                {
                    path: '',
                    name: 'dataQuery',
                    component: () => import(/* webpackChunkName:"dataQuery" */'./views/dataQuery'),
                    meta: {
                        menuIndex: 'dataQuery'
                    },
                },
            ]
        },
        {
            path: 'calculatorRestart',
            component: myRouteView,
            meta: {
                name: '数据查询',
                menuIndex: 'calculatorRestart'
            },
            children: [
                {
                    path: '',
                    name: 'calculatorRestart',
                    component: () => import('./views/calculatorRestart'),
                    meta: {
                        menuIndex: 'calculatorRestart'
                    },
                },
            ]
        },
        {
            path: 'userDataSystem',
            component: myRouteView,
            redirect: '/',
            meta: {
                name: '用户数据系统',
                menuIndex: 'userDataSystem',
                submenu: true
            },
            children: [
                {
                    path: 'onlinePlayer',
                    component: myRouteView,
                    meta: {
                        name: '在线玩家',
                        menuIndex: 'onlinePlayer'
                    },
                    children: [
                        {
                            path: '',
                            name: 'onlinePlayer',
                            component: () => import(/* webpackChunkName:"onlinePlayer" */'./views/userDataSystem/onlinePlayer'),
                            meta: {
                                name: '',
                                menuIndex: 'onlinePlayer'
                            }
                        },
                        {
                            path: 'onlinePlayerPushList',
                            name: 'onlinePlayerPushList',
                            component: () => import(/* webpackChunkName:"onlinePlayer" */'./views/userDataSystem/onlinePlayer/pushList'),
                            meta: {
                                name: '推送列表',
                                menuIndex: 'onlinePlayer'
                            }
                        }
                    ]
                },
                {
                    path: 'userLeaveTable',
                    name: 'userLeaveTable',
                    component: () => import('./views/userDataSystem/userLeaveTable'),
                    meta: {
                        name: '离桌用户列表',
                        menuIndex: 'userLeaveTable'
                    }
                },
                {
                    path: 'userLevelConfig',
                    name: 'userLevelConfig',
                    component: () => import(/* webpackChunkName:"userLevelConfig" */'./views/userDataSystem/userLevelConfig'),
                    meta: {
                        name: '用户层级设置',
                        menuIndex: 'userLevelConfig'
                    }
                },
                {
                    path: 'userLabel',
                    name: 'userLabel',
                    component: () => import(/* webpackChunkName:"userLabel" */'./views/userDataSystem/userLabel'),
                    meta: {
                        name: '玩家标签',
                        menuIndex: 'userLabel'
                    }
                },
                {
                    path: 'userWeightingData',
                    name: 'userWeightingData',
                    component: () => import(/* webpackChunkName:"userWeightingData" */'./views/userDataSystem/userWeightingData'),
                    meta: {
                        name: '加权数据统计',
                        menuIndex: 'userWeightingData'
                    }
                },
                {
                    path: 'userWeightingManager',
                    name: 'userWeightingManager',
                    component: () => import(/* webpackChunkName:"onlinePlayer" */'./views/userDataSystem/userWeightingManager'),
                    meta: {
                        name: '加权管理',
                        menuIndex: 'userWeightingManager'
                    }
                },
                {
                    path: 'privilegeUser',
                    name: 'privilegeUser',
                    component: () => import(/* webpackChunkName:"onlinePlayer" */'./views/userDataSystem/setPrivilegeUser'),
                    meta: {
                        name: '特权玩家',
                        menuIndex: 'privilegeUser'
                    }
                }
            ]
        },
        {
            path: 'promotionInfoQuery',
            component: myRouteView,
            redirect: '/',
            meta: {
                name: '推广信息查询',
                menuIndex: 'promotionInfoQuery',
                submenu: true
            },
            children: [
                {
                    path: 'clubPromotionData',
                    name: 'clubPromotionData',
                    component: () => import(/* webpackChunkName:'clubPromotionData' */ './views/promotionInfoQuery/clubPromotionData'),
                    meta: {
                        name: '俱乐部推广数据',
                        menuIndex: 'clubPromotionData'
                    }
                },
                {
                    path: 'channelPromotionData',
                    name: 'channelPromotionData',
                    component: () => import(/* webpackChunkName:"channelPromotionData" */ './views/promotionInfoQuery/channelPromotionData'),
                    meta: {
                        name: '渠道推广数据',
                        menuIndex: 'channelPromotionData'
                    }
                }
            ]
        },
        {
            path: 'marketingActivities',
            component: myRouteView,
            redirect: '/',
            meta: {
                name: '营销活动',
                menuIndex: 'marketingActivities',
                submenu: true
            },
            children: [
                {
                    path: 'redEnvelopeRainInGame',
                    name: 'redEnvelopeRainInGame',
                    component: () => import(/* webpackChunkName:"redEnvelopeRainInGame" */ './views/marketingActivities/redEnvelopeRainInGame'),
                    meta: {
                        name: '牌局内红包雨',
                        menuIndex: 'redEnvelopeRainInGame'
                    }
                },
                {
                    path: 'firstChargeRedEnvelope',
                    name: 'firstChargeRedEnvelope',
                    component: () => import(/* webpackChunkName:"firstChargeRedEnvelope" */ './views/marketingActivities/firstChargeRedEnvelope'),
                    meta: {
                        name: '首充红包',
                        menuIndex: 'firstChargeRedEnvelope'
                    }
                },
                {
                    path: 'playerActivitySearch',
                    name: 'playerActivitySearch',
                    component: () => import(/* webpackChunkName:"playerActivitySearch" */ './views/marketingActivities/playerActivitySearch'),
                    meta: {
                        name: '玩家活动查询',
                        menuIndex: 'playerActivitySearch'
                    }
                },
                {
                    path: 'horseRaceLamp',
                    name: 'horseRaceLamp',
                    component: () => import(/* webpackChunkName:"horseRaceLampTotal" */ './views/marketingActivities/horseRaceLamp'),
                    meta: {
                        name: '跑马灯小游戏',
                        menuIndex: 'horseRaceLamp'
                    }
                }
            ]
        },
        {
            path: 'gameSettings',
            component: myRouteView,
            redirect: '/',
            meta: {
                name: '游戏配置',
                menuIndex: 'gameSettings',
                submenu: true
            },
            children: [
                {
                    path: 'imageSetting',
                    name: 'imageSetting',
                    component: () => import(/* webpackChunkName: "imageSetting" */'./views/gameSettings/imageSetting'),
                    meta: {
                        name: '图片配置',
                        menuIndex: 'imageSetting'
                    }
                },
                {
                    path: 'maintenancePopUp',
                    name: 'maintenancePopUp',
                    component: () => import(/* webpackChunkName: "maintenancePopUp" */'./views/gameSettings/maintenancePopUp'),
                    meta: {
                        name: '维护弹窗内容',
                        menuIndex: 'maintenancePopUp'
                    }
                },
                {
                    path: 'backupDownload',
                    name: 'backupDownload',
                    component: () => import(/* webpackChunkName: "backupDownload" */'./views/gameSettings/backupDownload'),
                    meta: {
                        name: '备份下载',
                        menuIndex: 'backupDownload'
                    }
                },
                {
                    path: 'gameToConfigure',
                    name: 'gameToConfigure',
                    component: () => import(/* webpackChunkName: "backupDownload" */'./views/gameSettings/gameToConfigure'),
                    meta: {
                        name: '其他游戏配置',
                        menuIndex: 'gameToConfigure'
                    }
                },
                {
                    path: 'domainSwitch',
                    name: 'domainSwitch',
                    component: () => import(/* webpackChunkName: "domainSwitch" */'./views/gameSettings/domainSwitch'),
                    meta: {
                        name: '域名切换',
                        menuIndex: 'domainSwitch'
                    }
                },
                {
                    path: 'paymentPageSetting',
                    name: 'paymentPageSetting',
                    component: () => import(/* webpackChunkName: "paymentPageSetting" */'./views/gameSettings/paymentPageSetting'),
                    meta: {
                        name: '支付页面文案配置',
                        menuIndex: 'paymentPageSetting'
                    }
                }
            ]
        },
        {
            path: 'operatingInGame',
            component: myRouteView,
            redirect: '/',
            meta: {
                menuIndex: 'operatingInGame',
                name: '游戏内操作',
                submenu: true
            },
            children: [
                {
                    path: 'broadcast',
                    name: 'broadcast',
                    component: () => import(/* webpackChunkName:'broadcast' */ './views/operatingInGame/broadcast'),
                    meta: {
                        name: '广播',
                        menuIndex: 'broadcast',
                    }
                },
                {
                    path: 'dissolutionRoom',
                    name: 'dissolutionRoom',
                    component: () => import(/* webpackChunkName:'dissolutionRoom' */ './views/operatingInGame/dissolutionRoom'),
                    meta: {
                        name: '解散房间',
                        menuIndex: 'dissolutionRoom',
                    }
                },
                {
                    path: 'atDistribution',
                    component: myRouteView,
                    meta: {
                        name: 'AT分发',
                        menuIndex: 'atDistribution',
                    },
                    children: [
                        {
                            path: '',
                            name: 'atDistribution',
                            component: () => import(/* webpackChunkName:'atDistribution' */ './views/operatingInGame/atDistribution'),
                            meta: {
                                menuIndex: 'atDistribution'
                            }
                        },
                        {
                            path: 'atClubDetail',
                            name: 'atClubDetail',
                            component: () => import(/* webpackChunkName:'atDistribution' */ './views/operatingInGame/atDistribution/atClubDetail'),
                            meta: {
                                name: '俱乐部',
                                menuIndex: 'atDistribution'
                            }
                        }
                    ]
                },
                {
                    path: 'joinClub',
                    name: 'joinClub',
                    component: () => import(/* webpackChunkName:'joinClub' */ './views/operatingInGame/joinClub'),
                    meta: {
                        name: '加入俱乐部',
                        menuIndex: 'joinClub',
                    }
                },
                {
                    path: 'sendSystemMessage',
                    name: 'sendSystemMessage',
                    component: () => import(/* webpackChunkName:'sendSystemMessage' */ './views/operatingInGame/sendSystemMessage'),
                    meta: {
                        name: '发送系统消息',
                        menuIndex: 'sendSystemMessage',
                    }
                },
                {
                    path: 'cheatComplaint',
                    name: 'cheatComplaint',
                    component: () => import(/* webpackChunkName:'cheatComplaint' */ './views/operatingInGame/cheatComplaint'),
                    meta: {
                        name: '伙牌投诉',
                        menuIndex: 'cheatComplaint',
                    }
                },
                {
                    path: 'createAccountWithOneClick',
                    name: 'createAccountWithOneClick',
                    component: () => import(/* webpackChunkName:'createAccountWithOneClick' */ './views/operatingInGame/createAccountWithOneClick'),
                    meta: {
                        name: '一键创建账号',
                        menuIndex: 'createAccountWithOneClick',
                    }
                },
                {
                    path: 'personalDataEdit',
                    name: 'personalDataEdit',
                    component: () => import(/* webpackChunkName:'personalDataEdit' */ './views/operatingInGame/personalDataEdit'),
                    meta: {
                        name: '个人数据编辑',
                        menuIndex: 'personalDataEdit',
                    }
                },
                {
                    path: 'cardControl',
                    name: 'cardControl',
                    component: () => import(/* webpackChunkName:'cardControl' */ './views/operatingInGame/cardControl'),
                    meta: {
                        name: '控制发牌',
                        menuIndex: 'cardControl',
                    }
                }
            ]
        },
        {
            path: 'managementBodyInGame',
            component: myRouteView,
            redirect: '/',
            meta: {
                name: '游戏内主体管理',
                menuIndex: 'managementBodyInGame',
                submenu: true
            },
            children: [
                {
                    path: 'player',
                    component: myRouteView,
                    meta: {
                        name: '玩家列表',
                        menuIndex: 'player'
                    },
                    children: [
                        {
                            path: '',
                            name: 'player',
                            component: () => import(/* webpackChunkName: "player" */ './views/managementBodyInGame/player'),
                            meta: {
                                // name: '玩家列表',
                                menuIndex: 'player'
                            },
                        },
                        {
                            path: 'createRoomUserList',
                            name: 'createRoomUserList',
                            component: () => import(/* webpackChunkName: "player" */ './views/managementBodyInGame/player/createRoomUserList'),
                            meta: {
                                name: '开房权限列表',
                                menuIndex: 'player'
                            },
                        },
                        {
                            path: 'restrictedLoginList',
                            name: 'restrictedLoginList',
                            component: () => import(/* webpackChunkName: "player" */ './views/managementBodyInGame/player/restrictedLoginList'),
                            meta: {
                                name: '限制登录列表',
                                menuIndex: 'player'
                            },
                        },
                        {
                            path: 'integralUser/:id',
                            name: 'integralUser',
                            component: () => import(/* webpackChunkName: "player" */ './views/managementBodyInGame/integralUser/userIntegralDetail'),
                            meta: {
                                name: '玩家详细列表',
                                menuIndex: 'integralUser'
                            },
                        },
                    ]
                },
                {
                    path: 'club',
                    component: myRouteView,
                    meta: {
                        name: '我的俱乐部',
                        menuIndex: 'clubList'
                    },
                    children: [
                        {
                            path: '',
                            name: 'clubList',
                            component: () => import(/* webpackChunkName:"club" */ './views/managementBodyInGame/club/list'),
                            meta: {
                                menuIndex: 'clubList'
                            }
                        },
                        {
                            path: 'detail/:id',
                            name: 'clubDetail',
                            component: () => import(/* webpackChunkName:"club" */ './views/managementBodyInGame/club/detail'),
                            meta: {
                                name: '俱乐部详情',
                                menuIndex: 'clubList'
                            }
                        },
                        {
                            path: 'recommend',
                            name: 'clubRecommend',
                            component: () => import(/* webpackChunkName:"club" */ './views/managementBodyInGame/club/recommend'),
                            meta: {
                                name: '推荐俱乐部管理',
                                menuIndex: 'clubList'
                            }
                        }
                    ]
                },
                {
                    path: 'union',
                    component: myRouteView,
                    meta: {
                        name: '我的联盟',
                        menuIndex: 'unionList'
                    },
                    children: [
                        {
                            path: '',
                            name: 'unionList',
                            component: () => import(/* webpackChunkName:"union" */ './views/managementBodyInGame/union/list'),
                            meta: {
                                menuIndex: 'unionList'
                            }
                        },
                        {
                            path: 'detail/:id',
                            name: 'unionDetail',
                            component: () => import(/* webpackChunkName:"union" */ './views/managementBodyInGame/union/detail'),
                            meta: {
                                name: '联盟详情',
                                menuIndex: 'unionList'
                            }
                        },
                        {
                            path: 'clubDetail/:id',
                            name: 'unionClubDetail',
                            component: () => import(/* webpackChunkName:"club" */ './views/managementBodyInGame/club/detail'),
                            meta: {
                                name: '俱乐部详情',
                                menuIndex: 'unionList'
                            }
                        }
                    ]
                },
                {
                    path: 'auditManagement',
                    component: myRouteView,
                    meta: {
                        name: '审批管理',
                        submenu: true,
                        menuIndex: 'auditManagement'
                    },
                    children: [
                        {
                            path: 'clubChangePay',
                            name: 'managementMsgClubChangePay',
                            component: () => import(/* webpackChunkName:"auditManagement" */ './views/managementBodyInGame/auditManagement/clubChangePay'),
                            meta: {
                                name: '俱乐部更改交易模式申请',
                                menuIndex: 'managementMsgClubChangePay'
                            }
                        },
                        {
                            path: 'clubCreate',
                            name: 'managementMsgClubCreate',
                            component: () => import(/* webpackChunkName:"auditManagement" */ './views/managementBodyInGame/auditManagement/clubCreate'),
                            meta: {
                                name: '俱乐部创建申请',
                                menuIndex: 'managementMsgClubCreate'
                            }
                        },
                        {
                            path: 'tribeCreate',
                            name: 'managementMsgTribeCreate',
                            component: () => import(/* webpackChunkName:"auditManagement" */ './views/managementBodyInGame/auditManagement/tribeCreate'),
                            meta: {
                                name: '联盟创建申请',
                                menuIndex: 'managementMsgTribeCreate'
                            }
                        },
                        {
                            path: 'tribeJoin',
                            name: 'managementMsgTribeJoin',
                            component: () => import(/* webpackChunkName:"auditManagement" */ './views/managementBodyInGame/auditManagement/tribeJoin'),
                            meta: {
                                name: '俱乐部加入联盟申请',// 迁移到CMS了
                                menuIndex: 'managementMsgTribeJoin'
                            }
                        }
                    ]
                },
            ]
        },
        {
            path: 'searchInfoInGame',
            component: myRouteView,
            redirect: '/',
            meta: {
                name: '游戏内信息查询',
                menuIndex: 'searchInfoInGame',
                submenu: true
            },
            children: [
                {
                    path: 'playerJackpot',
                    name: 'playerJackpot',
                    component: () => import(/* webpackChunkName: "playerJackpot" */ './views/searchInfoInGame/playerJackpot'),
                    meta: {
                        name: '玩家彩池',
                        menuIndex: 'playerJackpot'
                    }
                },
                {
                    path: 'bringInfo',
                    name: 'bringInfo',
                    component: () => import(/* webpackChunkName: "bringInfo" */ './views/searchInfoInGame/bringInfo'),
                    meta: {
                        name: '带入信息',
                        menuIndex: 'bringInfo'
                    }
                },
                {
                    path: 'bringIp',
                    name: 'bringIp',
                    component: () => import(/* webpackChunkName: "bringIp" */ './views/searchInfoInGame/bringIp'),
                    meta: {
                        name: '带入IP',
                        menuIndex: 'bringIp'
                    }
                },
                {
                    path: 'playerGps',
                    name: 'playerGps',
                    component: () => import(/* webpackChunkName: "playerGps" */ './views/searchInfoInGame/playerGps'),
                    meta: {
                        name: '查询玩家GPS',
                        menuIndex: 'playerGps'
                    }
                },
                {
                    path: 'unionQuery',
                    name: 'unionQuery',
                    component: () => import(/* webpackChunkName: "unionQuery" */ './views/searchInfoInGame/unionQuery'),
                    meta: {
                        name: '联合查询',
                        menuIndex: 'unionQuery'
                    }
                },
                {
                    path: 'accountAssociated',
                    name: 'accountAssociated',
                    component: () => import(/* webpackChunkName: "accountAssociated" */ './views/searchInfoInGame/accountAssociated'),
                    meta: {
                        name: '账号关联',
                        menuIndex: 'accountAssociated'
                    }
                },
                {
                    path: 'newUserQuery',
                    name: 'newUserQuery',
                    component: () => import(/* webpackChunkName: "newUserQuery" */ './views/searchInfoInGame/newUserQuery'),
                    meta: {
                        name: '新增用户查询',
                        menuIndex: 'newUserQuery'
                    }
                }
            ]
        },
        {
            path: 'gameDetail',
            component: myRouteView,
            redirect: '/',
            meta: {
                name: '牌局信息',
                menuIndex: 'gameDetail',
                submenu: true
            },
            children: [
                {
                    path: 'platformUserStats',
                    name: 'platformUserStats',
                    component: () => import(/* webpackChunkName:"platformUserStats" */ './views/gameDetail/platformUserStats'),
                    meta: {
                        name: '平台玩家牌局信息',
                        menuIndex: 'platformUserStats'
                    }
                },
                {
                    path: 'platformRoomStats',
                    name: 'platformRoomStats',
                    component: () => import(/* webpackChunkName:"platformRoomStats" */ './views/gameDetail/platformRoomStats'),
                    meta: {
                        name: '平台牌局信息',
                        menuIndex: 'platformRoomStats'
                    }
                },

                {
                    path: 'tribeUserStats',
                    name: 'tribeUserStats',
                    component: () => import(/* webpackChunkName:"tribeUserStats" */ './views/gameDetail/tribeUserStats'),
                    meta: {
                        name: '联盟牌局信息',
                        menuIndex: 'tribeUserStats'
                    }
                },
                {
                    path: 'clubRoomStats',
                    name: 'clubRoomStats',
                    component: () => import(/* webpackChunkName:"clubRoomStats" */ './views/gameDetail/clubRoomStats'),
                    meta: {
                        name: '俱乐部牌局信息',
                        menuIndex: 'clubRoomStats'
                    }
                },
                {
                    path: 'userStats',
                    name: 'userStats',
                    component: () => import(/* webpackChunkName:"userStats" */ './views/gameDetail/userStats'),
                    meta: {
                        name: '用户牌局信息',
                        menuIndex: 'userStats'
                    }
                },
                {
                    path: 'batchUserStats',
                    name: 'batchUserStats',
                    component: () => import(/* webpackChunkName:"batchUserStats" */ './views/gameDetail/batchUserStats'),
                    meta: {
                        name: '战绩批量查询',
                        menuIndex: 'batchUserStats'
                    }
                }
            ]
        },
        {
            path: 'managementKingDou',
            component: myRouteView,
            redirect: '/',
            meta: {
                name: '金豆管理',
                menuIndex: 'managementKingDou',
                submenu: true
            },
            children: [
                {
                    path: 'marketingAccount',
                    name: 'marketingAccount',
                    component: () => import(/* webpackChunkName: "marketingAccount" */ './views/managementKingDou/marketingAccount'),
                    meta: {
                        name: '营销账户',
                        menuIndex: 'marketingAccount'
                    }
                },
                {
                    path: 'jpbStorehouse',
                    name: 'jpbStorehouse',
                    component: () => import(/* webpackChunkName: "jpbStorehouse" */ './views/managementKingDou/jpbStorehouse'),
                    meta: {
                        name: 'JPB仓',
                        menuIndex: 'jpbStorehouse'
                    }
                },
                {
                    path: 'manualRecharge',
                    name: 'manualRecharge',
                    component: () => import(/* webpackChunkName: "manualRecharge" */ './views/managementKingDou/manualRecharge'),
                    meta: {
                        name: '手工充值仓',
                        menuIndex: 'manualRecharge'
                    }
                },
                {
                    path: 'manualRechargeChip',
                    name: 'manualRechargeChip',
                    component: () => import(/* webpackChunkName:"manualRechargeChip" */ './views/managementKingDou/manualRechargeChip'),
                    meta: {
                        name: '手动充豆',
                        menuIndex: 'manualRechargeChip'
                    }
                },
                {
                    path: 'manualRechargePayChannelChip',
                    name: 'manualRechargePayChannelChip',
                    component: () => import(/* webpackChunkName:"manualRechargePayChannelChip" */ './views/managementKingDou/manualRechargePayChannelChip'),
                    meta: {
                        name: '手动充豆-代充渠道',
                        menuIndex: 'manualRechargePayChannelChip'
                    }
                },
                {
                    path: 'audit',
                    name: 'audit',
                    component: () => import(/* webpackChunkName: "audit" */ './views/managementKingDou/audit'),
                    meta: {
                        name: '审计系统',
                        menuIndex: 'audit'
                    }
                },
                {
                    path: 'jackpot',
                    component: myRouteView,
                    meta: {
                        name: '彩池',
                        menuIndex: 'jackpot'
                    },
                    children: [
                        {
                            path: '',
                            name: 'jackpot',
                            component: () => import(/* webpackChunkName: "jackpot"*/ './views/managementKingDou/jackpot'),
                            meta: {
                                menuIndex: 'jackpot'
                            }
                        },
                        {
                            path: 'log',
                            name: 'jackpotLog',
                            component: () => import(/* webpackChunkName: "jackpot"*/ './views/managementKingDou/jackpot/log'),
                            meta: {
                                name: '彩池记录',
                                menuIndex: 'jackpot'
                            }
                        }
                    ]
                },
                {
                    path: 'clientProductConfig',
                    name: 'clientProductConfig',
                    component: () => import(/* webpackChunkName:"clientProductConfig" */ './views/managementKingDou/clientProductConfig'),
                    meta: {
                        name: '商品配置',
                        menuIndex: 'clientProductConfig'
                    }
                }, {
                    path: 'inAppPurchaseConfig',
                    name: 'inAppPurchaseConfig',
                    component: () => import(/* webpackChunkName:"inAppPurchaseConfig" */ './views/managementKingDou/inAppPurchaseConfig'),
                    meta: {
                        name: '内购配置',
                        menuIndex: 'inAppPurchaseConfig'
                    }
                },
                {
                    path: 'managementPay',
                    name: 'managementPay',
                    component: () => import(/* webpackChunkName:"managementPay" */ './views/managementKingDou/managementPay'),
                    meta: {
                        name: '支付配置',
                        menuIndex: 'managementPay',
                    }
                },
                {
                    path: 'platformChannelConfig',
                    name: 'platformChannelConfig',
                    component: () => import(/* webpackChunkName:"platformChannelConfig" */ './views/managementKingDou/platformChannelConfig'),
                    meta: {
                        name: '平台渠道配置',
                        menuIndex: 'platformChannelConfig'
                    }
                },
                {
                    path: 'payChange',
                    name: 'payChange',
                    component: () => import(/* webpackChunkName:"payChange" */ './views/managementKingDou/payChange'),
                    meta: {
                        name: '支付切换',
                        menuIndex: 'payChange'
                    }
                },
                {
                    path: 'mallPayChannelConfig',
                    name: 'mallPayChannelConfig',
                    component: () => import(/* webpackChunkName:"mallPayChannelConfig" */ './views/managementKingDou/mallPayChannelConfig'),
                    meta: {
                        name: '商城支付通道配置',
                        menuIndex: 'mallPayChannelConfig'
                    }
                },
                {
                    path: 'rechargeOrder',
                    name: 'rechargeOrder',
                    component: myRouteView,
                    meta: {
                        name: '充值订单',
                        menuIndex: 'rechargeOrder',
                        submenu: true
                    },
                    children: [
                        {
                            path: 'centerRechargeOrder',
                            name: 'centerRechargeOrder',
                            component: () => import(/* webpackChunkName:"centerRechargeOrder" */ './views/managementKingDou/rechargeOrder/centerRechargeOrder'),
                            meta: {
                                name: '中央收付充值',
                                menuIndex: 'centerRechargeOrder'
                            },
                        }, {
                            path: 'clubRechargeOrder',
                            name: 'clubRechargeOrder',
                            component: () => import(/* webpackChunkName:"clubRechargeOrder" */ './views/managementKingDou/rechargeOrder/clubRechargeOrder'),
                            meta: {
                                name: 'CMS俱乐部充值订单',
                                menuIndex: 'clubRechargeOrder'
                            },
                        },
                        {
                            path: 'payChannelRechargeOrder',
                            name: 'payChannelRechargeOrder',
                            component: () => import(/* webpackChunkName:"payChannelRechargeOrder" */ './views/managementKingDou/rechargeOrder/payChannelRechargeOrder'),
                            meta: {
                                name: 'CMS代充渠道充值订单',
                                menuIndex: 'payChannelRechargeOrder'
                            },
                        },
                        {
                            path: 'playerRechargeOrder',
                            name: 'playerRechargeOrder',
                            component: () => import(/* webpackChunkName:"playerRechargeOrder" */ './views/managementKingDou/rechargeOrder/playerRechargeOrder'),
                            meta: {
                                name: '玩家平台充值订单',
                                menuIndex: 'playerRechargeOrder'
                            },
                        },
                        {
                            path: 'playerMallRechargeOrder',
                            name: 'playerMallRechargeOrder',
                            component: () => import(/* webpackChunkName:"playerMallRechargeOrder" */ './views/managementKingDou/rechargeOrder/playerMallRechargeOrder'),
                            meta: {
                                name: '玩家商城充值订单',
                                menuIndex: 'playerMallRechargeOrder'
                            },
                        }
                    ]
                },
                {
                    path: 'takeDouMessageManage',
                    name: 'takeDouMessageManage',
                    component: () => import(/* webpackChunkName:"takeDouMessageManage" */ './views/managementKingDou/takeDouMessageManage'),
                    meta: {
                        name: '提豆信息管理',
                        menuIndex: 'takeDouMessageManage'
                    }
                },
                {
                    path: 'takeDouMessageUpdateAudit',
                    name: 'takeDouMessageUpdateAudit',
                    component: () => import(/* webpackChunkName:"takeDouMessageUpdateAudit" */ './views/managementKingDou/takeDouMessageUpdateAudit'),
                    meta: {
                        name: '提豆信息修改审核',
                        menuIndex: 'takeDouMessageUpdateAudit'
                    }
                },
                {
                    path: 'takeDou',
                    name: 'takeDou',
                    component: () => import(/* webpackChunkName:"takeDouMessageUpdateAudit" */ './views/managementKingDou/takeDou'),
                    meta: {
                        name: '提豆管理',
                        menuIndex: 'takeDou'
                    }
                }
            ]
        },
        {
            path: 'managementPumping',
            name: 'managementPumping',
            component: () => import(/* webpackChunkName:"accountManagement" */ './views/managementPumping'),
            meta: {
                name: '抽水管理',
                menuIndex: 'managementPumping'
            }
        },
        {
            path: 'extractChipRechargeOrder',
            name: 'extractChipRechargeOrder',
            component: () => import(/* webpackChunkName:"extractChipRechargeOrder" */ './views/extractChipRechargeOrder'),
            meta: {
                name: '提豆订单',
                menuIndex: 'extractChipRechargeOrder'
            }
        },
        {
            path: 'operationRecord',
            name: 'operationRecord',
            component: myRouteView,
            meta: {
                name: '操作记录',
                submenu: true,
                menuIndex: 'operationRecord'
            },
            children: [
                {
                    path: 'approvalRecord',
                    name: 'approvalRecord',
                    component: () => import(/* webpackChunkName:"approvalRecord" */ './views/operationRecord/approvalRecord'),
                    meta: {
                        name: '审批记录',
                        menuIndex: 'approvalRecord'
                    }
                }
            ]
        },
        {
            path: 'takeDouManage',
            name: 'takeDouManage',
            component: myRouteView,
            meta: {
                name: '提豆管理',
                submenu: true,
                menuIndex: 'takeDouManage'
            },
            children: [
                {
                    path: 'takeDouExamine',
                    name: 'takeDouExamine',
                    component: () => import(/* webpackChunkName:"takeDouExamine" */ './views/managementTakeDou/takeDouExamine'),
                    meta: {
                        name: '提豆审核',
                        menuIndex: 'takeDouExamine'
                    }
                }
            ]
        },
        {
            path: 'managementMtt',
            name: 'managementMtt',
            component: myRouteView,
            meta: {
                name: '官方MTT',
                submenu: true,
                menuIndex: 'managementMtt'
            },
            children: [
                {
                    path: 'createMtt',
                    component: myRouteView,
                    meta: {
                        name: '创建比赛',
                        menuIndex: 'createMtt',
                        keepAlive:true,
                    },
                    children: [
                        {
                            path: '',
                            name: 'createMtt',
                            component: () => import( './views/managementMtt/createMtt'),
                            meta: {
                                keepAlive:true,
                                menuIndex: 'createMtt'
                            },
                        },
                        {
                            path: 'rewardMtt',
                            name: 'rewardMtt',
                            component: () => import( './views/managementMtt/createMtt/rewardMtt'),
                            meta: {
                                name: '玩家奖励列表',
                                keepAlive:false,
                                menuIndex: 'rewardMtt'
                            }
                        },
                        {
                            path: 'mangZhuGrade/:type',
                            name: 'mangZhuGrade',
                            component: () => import( './views/managementMtt/createMtt/mangZhuGrade'),
                            meta: {
                                name: '玩家奖励列表',
                                keepAlive:false,
                                menuIndex: 'mangZhuGrade'
                            }
                        },
                    ]
                },

                {
                    path: 'mttList',
                    name: 'mttList',
                    component: () => import(/* webpackChunkName:"mttList" */ './views/managementMtt/mttList'),
                    meta: {
                        name: '比赛列表',
                        menuIndex: 'mttList'
                    }
                },
                
                {
                    path: 'RewardDistribution',
                    component: myRouteView,
                    meta: {
                        name: '奖励发放',
                        menuIndex: 'RewardDistribution'
                    },
                    children:[
                        {
                            path: '',
                            name: 'RewardDistribution',
                            component: () => import(/* webpackChunkName:"mttList" */ './views/managementMtt/RewardDistribution/main'),
                            meta: {
                                name: '',
                                menuIndex: 'RewardDistribution'
                            }
                        },
                        {
                            path: 'awardDetail',
                            name: 'awardDetail',
                            component: () => import(/* webpackChunkName:"mttList" */ './views/managementMtt/RewardDistribution/awardDetail'),
                            meta: {
                                name: '赛事详情',
                                menuIndex: 'RewardDistribution'
                            }
                        }
                    ]
                }
            ]
        }
    ]
}];